<template>
  <div class="content-container">
    <!-- 页面标题 -->
    <achiTitle title="科技金融" subtitle="科技赋能，金融助力，创新未来" />
    <!-- 循环展示两段核心文本 -->
    <div class="text-item" v-for="(item, index) in txts" :key="index">
      <h2> {{ item.title }}</h2>
      <div>{{ item.content }}</div>
    </div>


  </div>
</template>

<script>
import achiTitle from '../components/achievement/achi_title.vue';

export default {
  name: 'FundInfoPage',
  components: {
    achiTitle
  },
  data() {
    return {
      // 核心文本数组，用于循环展示

      txts: [{
        title: "设立辽宁省培育创业创新基金",
        content: '该基金由辽宁药都投资管理有限公司联合辽宁控股（集团）有限责任公司、辽宁基金投资有限公司、辽宁科技创业投资有限责任公司共同发起，总规模达1.5亿元。基金聚焦医疗器械、生物制药等大健康产业细分领域，重点扶持处于初创期、成长期的未上市中小型创新企业；同时延伸覆盖新一代信息技术、先进装备制造、新能源、新材料等战略性新兴产业方向。',
      },
      {
        title: "设立本溪高新区科技信贷风险补偿资金池",
        content: '该资金池由辽宁省科学技术厅与本溪高新区管理委员会共同出资设立，初始规模2000万元。其主要职能是为符合条件的科技型企业提供信贷风险补偿支持，具体面向具有独立法人资格、符合产业政策导向的科技型中小企业、高新技术企业、“专精特新”企业、雏鹰瞪羚企业等，支持其非实物抵押的融资需求。'

      }],
      // 单独的联系方式
      contactNumber: '(024)45627612'
    }
  }
}
</script>

<style scoped>
/* 基础样式，提升页面可读性 */
.content-container {
  width: 40%;
  margin: 20px auto;
  padding: 0 20px;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

/* 文本项样式 */
.text-item {
  margin-bottom: 25px;
  text-align: justify;
}

/* 联系方式样式 */
.contact-info {
  margin-top: 30px;
  padding-top: 15px;
  border-top: 1px solid #eee;
  font-weight: 500;
}
</style>